import { SensoresApi } from '@/domain/entities/Api'
import { stringToHash } from '@/components/helpers/stringToHash'
import { GroundOverlayProps } from './GroundOverlayProps'

export interface SensoresOverlaysProps {
  NieveMODIS?: GroundOverlayProps[]
  PrecipitacionIMERG?: GroundOverlayProps[]
  IncendioFIRMS?: GroundOverlayProps[]
}

const assesImagenesSatelitalesImages = (imagenesSatelitales: SensoresApi): boolean => {
  return !!(imagenesSatelitales && imagenesSatelitales.imagenes)
}

const getImagenesSatelitalesOverlays = (sensores: SensoresApi, current: number): SensoresOverlaysProps => {
  if (assesImagenesSatelitalesImages(sensores)) {
    const getOverlays = (imagen: string, sensores: SensoresApi, index: number) => {
      const bounds = {
        south: sensores.latlong[0][0],
        north: sensores.latlong[1][0],
        west: sensores.latlong[0][1],
        east: sensores.latlong[1][1]
      }
      const source = `https://pronosticos.alertaaire.cl${sensores.ruta}/${imagen}`
      return {
        options: { opacity: 1 },
        bounds,
        source,
        isShown: index === current,
        hash: stringToHash(source)
      }
    }

    return {
      NieveMODIS: sensores.imagenes.NieveMODIS.map((imagen: string, index: number) => {
        return getOverlays(imagen, sensores, index)
      }),
      PrecipitacionIMERG: sensores.imagenes.PrecipitacionIMERG.map((imagen: string, index: number) => {
        return getOverlays(imagen, sensores, index)
      }),
      IncendioFIRMS: sensores.imagenes.IncendioFIRMS.map((imagen: string, index: number) => {
        return getOverlays(imagen, sensores, index)
      })
    }
  } else {
    return {}
  }
}

export { assesImagenesSatelitalesImages }
